import { makeStyles, useAnnounce } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { Report } from '../../../model';
import { cometDarkTheme, customPalette } from '../../../theme';
import { DefaultTooltipHostV9 } from '../../common/DefaultTooltipHostV9';
import NoCollateralWarningIcon from './NoCollateralWarningIcon';

export interface IBulkEditReportNameCellProps {
    item: Pick<Report, 'name' | 'canExecute' | 'id' | 'executeWarningMessage'>;
    viewTaxReturnsEnabled: boolean | undefined;
}

const useStyles = makeStyles({
    cellContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        minWidth: 0,
    },
    disabledItem: {
        color: cometDarkTheme.colorNeutralStrokeDisabled,
    },
    reportNameText: {
        color: customPalette.blueDark,
        whiteSpace: 'nowrap',
        fontSize: '14px',
        lineHeight: '24px',
        fontWeight: 600,
    },
});

const BulkEditReportNameCell = ({ item, viewTaxReturnsEnabled }: IBulkEditReportNameCellProps) => {
    const { t } = useTranslation();
    const { announce } = useAnnounce();
    const styles = useStyles();

    const announceNoFunctionalAccess = () => {
        announce(t('noFunctionalAccess').toString(), { batchId: `reports-no-functional-access-${item.id}` });
    };

    if (!viewTaxReturnsEnabled) {
        return (
            <DefaultTooltipHostV9 content={t('noFunctionalAccess').toString()} relationship='label' alwaysDisplay>
                <div className={styles.cellContainer}>
                    <label
                        tabIndex={0}
                        className={styles.disabledItem}
                        aria-disabled
                        onPointerEnter={announceNoFunctionalAccess}
                        onFocus={announceNoFunctionalAccess}
                    >
                        {item.name}
                    </label>
                </div>
            </DefaultTooltipHostV9>
        );
    }

    return (
        <div className={styles.cellContainer}>
            {!item.canExecute && <NoCollateralWarningIcon item={item} />}
            <DefaultTooltipHostV9 content={item.name ?? ''} relationship='label'>
                <span className={styles.reportNameText}>{item.name}</span>
            </DefaultTooltipHostV9>
        </div>
    );
};

export default BulkEditReportNameCell;
